import Skeleton from 'react-loading-skeleton';

const DashboardHeaderSkeleton = () => (
  <div className="space-y-4">
    {/* Title + subtitle */}
    <div>
      <h1 className="text-3xl lg:text-4xl font-black leading-tight">
        <Skeleton width={250} />
      </h1>
      <p className="text-base lg:text-lg text-content-secondary font-medium opacity-90">
        <Skeleton width={200} />
      </p>
    </div>

    {/* RankCard skeleton */}
    <div className="relative rounded-xl overflow-hidden border-2 border-border bg-background-secondary/70">
      <div className="flex flex-col sm:flex-row items-stretch">

        {/* Left — rank label + progress bar */}
        <div className="flex-shrink-0 sm:basis-1/4 p-3 sm:p-4">
          <div className="flex sm:flex-col items-center gap-3 sm:gap-2">
            <Skeleton width={64} height={36} borderRadius={6} />
            <div className="flex-1 sm:flex-none sm:w-full space-y-1">
              <Skeleton height={6} borderRadius={999} />
              <Skeleton width={90} height={10} />
            </div>
          </div>
        </div>

        {/* Dividers */}
        <div className="sm:hidden h-px bg-border" />
        <div className="hidden sm:block w-px self-stretch bg-border flex-shrink-0" />

        {/* Right — 4 stat columns */}
        <div className="flex-1 grid grid-cols-4">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="flex flex-col items-center justify-center p-2 sm:p-3 lg:p-4 text-center gap-0.5 sm:gap-1">
              <div className="hidden sm:block mb-1">
                <Skeleton circle width={32} height={32} />
              </div>
              <Skeleton width={40} height={22} />
              <Skeleton width={48} height={10} />
            </div>
          ))}
        </div>

      </div>
    </div>
  </div>
);

export default DashboardHeaderSkeleton;
